function initializeScript() {
    waitForElement("#oke-loyalty-earn", (targetNode) => {
        initObserver(targetNode);
        changeButtonLink();
    });
}

// Initial page load
window.addEventListener("load", initializeScript);

// Browser back/forward cache restore
window.addEventListener("pageshow", function (event) {
    // event.persisted === true means restored from bfcache
    if (event.persisted) {
        console.log("Page restored from back-forward cache");
        initializeScript();
    }
});

function waitForElement(selector, callback, timeout = 10000) {
    const interval = 300;
    let elapsed = 0;

    const timer = setInterval(() => {
        const el = document.querySelector(selector);

        if (el) {
            clearInterval(timer);
            callback(el);
        }

        elapsed += interval;

        if (elapsed >= timeout) {
            clearInterval(timer);
            console.warn(selector + " not found within timeout");
        }
    }, interval);
}

function initObserver(targetNode) {
    // Prevent duplicate observers
    if (targetNode.dataset.observerAttached) return;

    targetNode.dataset.observerAttached = "true";

    const observer = new MutationObserver(() => {
        changeButtonLink();
    });

    observer.observe(targetNode, {
        childList: true,
        subtree: true
    });
}

function changeButtonLink() {
    if (window.okeWidgetApi) {
        const titles = document.querySelectorAll(
            '#oke-loyalty-earn .c-customisableActionCard-titleArea-title'
        );

        for (const el of titles) {
            if (el.textContent.trim() === "Place an Order") {
                const card = el.closest('.c-customisableActionCard');

                if (!card) continue;

                const button = card.querySelector('.c-button--customisable');

                if (button) {

                    // Prevent duplicate listeners
                    if (button.dataset.redirectAttached) break;

                    button.dataset.redirectAttached = "true";

                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        window.location.href = "/collections/all";
                    });

                    break;
                }
            }
        }
    }
}